import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";

// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import {
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";

import * as TipoDeError from "../../isp._comun/services/Errores";

import DataDeRespuestas_Facturacion from "../../isp.žapi.items/DataEstaticaDeRespuestas.json";

import ItemReducer from "../reductores/ItemReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";
import CargaDeItemConsultado from "../reductores/acciones/dispatch/CargaDeItemConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoItemLayout from "./layouts/DialogoItemLayout";
// import { TipoDeItem } from "../../reductores/Constantes";

import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";

import ServiceRegistroDeItem from "../../isp.žapi.items/ServiceRegistroDeItem";
import ServiceActualizacionDeItem from "../../isp.žapi.items/ServiceActualizacionDeItem";
import ServiceQueryUnItem from "../../isp.žapi.items/ServiceQueryUnItem";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import { ModosOp } from "../../../_comun/Constantes";

const DialogoItem = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        handleErroresExtraEnPrincipal,
        notificar,
    } = useContext(GlobalContext);

    const [estadoDCF, dispatchDCF] = useReducer(ItemReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;

    const serviceRegistroDeItem = new ServiceRegistroDeItem();
    const registrarItemCommand = new ComandoAPI(serviceRegistroDeItem);
    registrarItemCommand.ejecutar = async () => {
        const item = {
            tipoItem: estadoDCF.domain.screen.tipoItem,
            nombre: estadoDCF.domain.screen.nombre,
            descripcion: estadoDCF.domain.screen.descripcion,
            precio: estadoDCF.domain.screen.precio,
            moneda: estadoDCF.domain.screen.moneda,
            udm: estadoDCF.domain.screen.udm,
        };

        try {
            // const servicio = new ServicioRegistroDeItem();
            // registrarItemCommand.servicio = servicio;

            // const dataRegistradaDeItem = await servicio.ejecutar(item);
            const dataRegistradaDeItem = await serviceRegistroDeItem.ejecutar(item);
            // await new ServicioRegistroDeClienteAFacturar().ejecutar(item);
            dispatchDCF(new Action.CargaDeItemRegistrado(dataRegistradaDeItem));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.titulo,
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.mensaje,
                    dataRegistradaDeItem.idItem
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearItem(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    const serviceApiActualizacionDeItem = new ServiceActualizacionDeItem();
    const actualizarItemCommand = new ComandoAPI(serviceApiActualizacionDeItem);
    actualizarItemCommand.ejecutar = async () => {
        const itemPorActualizar = {
            id: estadoDCF.domain.screen.idItem,
            data: estadoDCF.domain.update,
        };

        try {
            await serviceApiActualizacionDeItem.ejecutar(itemPorActualizar);
            dispatchDCF(
                new Action.CargaDeItemActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarItem(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    const serviceApiQueryUnItem = new ServiceQueryUnItem();
    const buscarUnSoloItemCommand = new ComandoAPI(serviceApiQueryUnItem);
    buscarUnSoloItemCommand.ejecutar = async (idItem) => {
        try {
            // const servicio = new ServicioDeQueryDeUnItem();
            // buscarUnSoloItemCommand.servicio = servicio;
            const respuestaQuery = await serviceApiQueryUnItem.ejecutar(idItem);
            dispatchDCF(new CargaDeItemConsultado(respuestaQuery.item));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoItemLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            // registrarClienteAFacturar={useHandlerDeServicio(registrarClienteAFacturar)}
            registrarItemCommand={registrarItemCommand}
            // actualizarClienteAFacturar={useHandlerDeServicio(actualizarClienteAFacturar)}
            actualizarItemCommand={actualizarItemCommand}
            // buscarUnSoloClienteAFacturar={buscarUnSoloClienteAFacturar}
            buscarUnSoloItemCommand={buscarUnSoloItemCommand}
        />
    );
};

export default DialogoItem;
